import config from '@plone/volto/registry';

/**
 * Prefixo de subcaminho sob o qual o portal está publicado (AB#12105).
 *
 * O hub do MPF publica o portal em `novoportal.mpf.mp.br/mpf`. O Volto 19
 * (e o core 18.35 com o patch `volto-18.35.0-subpath-upstream-6897`) guarda
 * esse prefixo em `config.settings.subpathPrefix` e o aplica ao roteador
 * (`basename`) e ao componente `Image`. O que o tema monta por conta própria
 * em `<img src>`, `<a href>` ou no DOM continua relativo à raiz do host e, no
 * hub, apontaria para outro sistema. Este helper fecha essa lacuna.
 *
 * Sem prefixo configurado (site na raiz, ambiente de desenvolvimento sem o
 * patch), devolve a entrada como está.
 */
export function prefixoDoSite(): string {
  const prefixo = (config.settings as { subpathPrefix?: string }).subpathPrefix;
  return prefixo ? prefixo.replace(/\/+$/, '') : '';
}

/**
 * Acrescenta o prefixo do site a um caminho relativo à raiz (`/x/y`).
 *
 * Deixa passar endereços absolutos (`https://…`), protocolo-relativos (`//…`),
 * âncoras, `data:` e caminhos que já carregam o prefixo. Idempotente.
 */
export function comPrefixo<T>(caminho: T): T {
  if (typeof caminho !== 'string') return caminho;
  const prefixo = prefixoDoSite();
  if (!prefixo) return caminho;
  if (!caminho.startsWith('/') || caminho.startsWith('//')) return caminho;
  if (caminho === prefixo || caminho.startsWith(`${prefixo}/`)) return caminho;
  return `${prefixo}${caminho}` as T;
}
